import { render, staticRenderFns } from "./PostAnsatt.vue?vue&type=template&id=4eead08e&"
import script from "./PostAnsatt.vue?vue&type=script&lang=js&"
export * from "./PostAnsatt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports